<template lang="html">
  <div class="editor">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="textsw">
    </div>
  </div>
</template>

<script>
  import E from 'wangeditor'
 import {API} from "@/axios/config";
  export default {
    name: 'editoritem',
    data() {
      return {
        // uploadPath,
        editor: null,
        info_: null,
        upload: API.UploadsService + "backstage/annex/file"
      }
    },
    model: {
      prop: 'EditorCont',
      event: 'change'
    },
    props: {
      EditorCont: {
        type: String,
        default: ''
      },
      isClear: {
        type: Boolean,
        default: false
      }
    },
    created(){
        console.log()
    },
    watch: {
      isClear(val) {
        // 触发清除文本域内容
        if (val) {
          this.editor.txt.clear()
          this.info_ = null
        }
      },
      EditorCont: function(value) {
        if (value !== this.editor.txt.html()) {
          this.editor.txt.html(this.EditorCont)
        }
      }
      //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
    },
    mounted() {
      this.seteditor()
      this.editor.txt.html(this.value)
    },
    methods: {
      seteditor() {
        // http://192.168.2.125:8080/admin/storage/create
        this.editor = new E(this.$refs.toolbar, this.$refs.editor)
        this.editor.customConfig.uploadImgShowBase64 = false // base 64 存储图片
        this.editor.customConfig.uploadImgServer = this.upload// 配置服务器端地址
        this.editor.customConfig.uploadImgHeaders = {
            Authorization: "Bearer " + JSON.parse(window.localStorage.getItem("vuex")).user.token
        };
        this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
        this.editor.customConfig.uploadImgMaxSize = 20 * 1024 * 1024 // 将图片大小限制为 2M
        // this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
        this.editor.customConfig.uploadImgTimeout = 100000 // 设置超时时间

        // 配置菜单
        this.editor.customConfig.menus = [
          'head', // 标题
          'bold', // 粗体
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'underline', // 下划线
          'strikeThrough', // 删除线
          'foreColor', // 文字颜色
          'backColor', // 背景颜色
          'link', // 插入链接
          'list', // 列表
          'justify', // 对齐方式
          'image', // 插入图片
          'table', // 表格
          'undo', // 撤销
          'redo', // 重复
          'fullscreen' // 全屏
        ]

        this.editor.customConfig.uploadImgHooks = {
          fail: (xhr, editor, result) => {
            // 插入图片失败回调
            // this.$alert('插入图片失败');
          },
          success: (xhr, editor, result) => {
            // 图片上传成功回调
            // this.$alert('图片上传成功');
          },
          timeout: (xhr, editor) => {
            // 网络超时的回调
            // this.$alert('网络超时,请重新上传');
          },
          error: (xhr, editor) => {
            // 图片上传错误的回调
            // this.$alert('图片上传错误，请重新上传');
          },
          customInsert: (insertImg, result, editor) => {
              var url = result.data.frontPath + result.data.filePath;
                insertImg(url);
          }
        }
        this.editor.customConfig.onchange = (html) => {
          this.info_ = html // 绑定当前逐渐地值
          this.$emit('onEditorChange', this.info_) // 将内容同步到父组件中
        }
        // 创建富文本编辑器
        this.editor.create()
      }
    }
  }
</script>

<style lang="css">
  .editor {
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 0;
  }
  .w-e-toolbar{
      flex-wrap: wrap;
  }
  .toolbar {
    border: 1px solid #ccc;
  }
  .textsw {
    border: 1px solid #ccc;
    min-height: 500px;
  }
  .w-e-text{
      overflow: auto;
  }
</style>